import React from 'react';
const ThreeDots = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "6", viewBox: "0 0 18 6" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { fill: "#FFF" },
                React.createElement("g", { transform: "translate(-316 -634) translate(316 634)" },
                    React.createElement("circle", { cx: "2.56", cy: "2.56", r: "2.56" }),
                    React.createElement("circle", { cx: "8.96", cy: "2.56", r: "2.56" }),
                    React.createElement("circle", { cx: "15.36", cy: "2.56", r: "2.56" }))))));
};
export default ThreeDots;
//# sourceMappingURL=index.js.map